"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserDonationTypes = exports.setTranslations = exports.setAppSettings = exports.setSidebarOpen = exports.setPages = exports.setUser = exports.appSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const lodash_1 = require("lodash");
const initialState = {
    user: null,
    pages: null,
    sidebarOpen: false,
    appSettings: null,
    translations: undefined,
};
exports.appSlice = (0, toolkit_1.createSlice)({
    name: 'app',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setPages: (state, action) => {
            state.pages = action.payload;
        },
        setSidebarOpen: (state, action) => {
            state.sidebarOpen = action.payload;
        },
        setAppSettings: (state, action) => {
            state.appSettings = action.payload;
        },
        setTranslations: (state, action) => {
            state.translations = action.payload;
        },
    },
});
_a = exports.appSlice.actions, exports.setUser = _a.setUser, exports.setPages = _a.setPages, exports.setSidebarOpen = _a.setSidebarOpen, exports.setAppSettings = _a.setAppSettings, exports.setTranslations = _a.setTranslations;
// Selectors
exports.getUserDonationTypes = (0, toolkit_1.createSelector)([(state) => state.app.user.donorDonationTypeDatas], (donorDonationTypeDatas) => (0, lodash_1.map)(donorDonationTypeDatas, (d) => ({
    donationType: d.donationType,
    donationTypeEnum: d.donationTypeEnum,
})));
exports.default = exports.appSlice.reducer;
